import React from 'react';
import Pagination from '@mui/material/Pagination';

/**
 * @typedef {object} PaginationControlsProps
 * @property {number} currentPage
 * @property {number} totalPages
 * @property {(pageNumber: number) => void} onClick
 */

/**
 * @param {PaginationControlsProps} props
 */
const PaginationControls = props => {
  const { currentPage, totalPages, onClick } = props;
  if (!currentPage || totalPages <= 1) {
    return null;
  }

  return (
    <Pagination
      count={totalPages}
      page={currentPage}
      onChange={(_, pageNumber) => {
        onClick(pageNumber);
      }}
    />
  );
};

export default PaginationControls;
